const HEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;
const RGB = /^rgba?\(/i;
const VAR_FALLBACK = /var\([^,]+,\s*(#[0-9a-f]{3}\b|#[0-9a-f]{6}\b|rgba?\([^)]*\))\s*\)$/i;

/**
 * pack-opener-js parses `#hex` and `rgb()` only, while the reveal's rarity
 * colours are `var(--ui-badge-…, #fallback)` expressions (see glowColorFor).
 * Resolve through the DOM so a Design Constructor override of the badge colour
 * reaches the scene; fall back to the expression's own default when the
 * environment cannot compute it (jsdom, a var that is not defined).
 */
export function resolveCssColor(expression: string, fallback = '#ffffff'): string {
  const text = expression.trim();
  if (HEX.test(text) || RGB.test(text)) return text;

  if (typeof document !== 'undefined' && document.body) {
    const probe = document.createElement('span');
    probe.style.color = text;
    // A value the engine rejected leaves the property empty; computing it then
    // would only report the inherited colour, not the expression
    if (probe.style.color !== '') {
      document.body.appendChild(probe);
      const computed = getComputedStyle(probe).color;
      probe.remove();
      if (RGB.test(computed)) return computed;
    }
  }

  const inline = VAR_FALLBACK.exec(text);
  return inline?.[1] ?? fallback;
}
